const NAME = "TYPES_OF_SKILLS_SPECIFIC";

export default NAME;
